/**
 * 3rd party vendor libraries
 * Lazy loaded when needed
 */

import WebSocketAsPromised from 'websocket-as-promised';
import axios from 'axios';
import { isValidURL } from 'util';

Genesys('registerPlugin', 'GenesysVendors', (Vendors) => {
  Vendors.registerCommand('WebSocket', (e) => {
    const { endPoint } = e.data || {};
    const deploymentConfig = Vendors.data('GenesysJS.deploymentConfig') || {};
    const { messenger } = deploymentConfig || {};
    const { apps } = messenger || {};
    const { conversations } = apps || {};
    const { messagingEndpoint } = conversations || {};

    if (endPoint) {
      const oURL = new URL(endPoint);

      // WEBMESS-1813: compare if the origin of the web socket url belongs to ours

      if (messagingEndpoint.includes(oURL.origin)) {
        e.resolve(WebSocketAsPromised);
      } else {
        e.reject('Unauthorized Access!');
      }
    } else {
      e.reject('Invalid Endpoint');
    }
  });

  Vendors.registerCommand('Axios', (e)=>{
    const { url } = e.data || {};

    if (isValidURL(url)) {
      const oURL = new URL(url);
      const serviceApiV2 = Vendors.data('ServiceDiscovery.uris.apiV2'); // from config
      const aAPIOrigins = Vendors.data('MessengerHelper.apiOrigins') || []; // from messages
      const oServiceApi = new URL(serviceApiV2);

      if (oServiceApi.origin && !aAPIOrigins.includes(oServiceApi.origin)) aAPIOrigins.push(oServiceApi.origin);

      // WEBMESS-1813: compare if the origin of the url belongs to one of our service discovery api urls

      if (aAPIOrigins.includes(oURL.origin)) {
        e.resolve(axios);
      } else {
        e.reject('Unauthorized Access!');
      }
    } else {
      e.reject('Invalid URL');
    }
  });

  Vendors.ready();
});
